import { useEffect, useState, useContext } from "react";
import Account from "../../models/account";
import { useNavigate } from "react-router-dom";
import accountService from "../../services/accountService";
import AccountLink from "../../components/work/AccountLink";
import User from "../../models/user";
import UserContext from "../../contexts/userContext";
import SubscriptionContextModel from "../../contexts/subscriptionContextModel";
import SubscriptionContext from "../../contexts/subscriptionContext";
import Page from "../../components/work/layout/Page";
import SearchBar from "../../components/work/layout/SearchBar";

const Accounts: React.FC = () => {
  const navigate = useNavigate();

  const user = useContext<User | undefined>(UserContext);
  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [accounts, setAccounts] = useState<Account[]>([]);
  const [allAccounts, setAllAccounts] = useState<Account[]>([]);
  const [accountSearch, setAccountSearch] = useState<string>("");

  useEffect(() => {
    const init = async () => {
      try {
        if (user) {
          const { data: accounts } = await accountService.getAccounts(
            subscription.idSubscription,
          );
          setAccounts(accounts);
          setAllAccounts(accounts);
        }
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    init();
  }, [user, subscription]);

  const onSearchChange = (event: any) => {
    setAccountSearch(event.target.value);
    const searchToken = event.target.value.toLowerCase();
    const newAccounts = allAccounts.filter((a) =>
      a.accountName.toLowerCase().includes(searchToken),
    );
    setAccounts(newAccounts);
  };

  const onCreateAccountClick = () => {
    navigate("/work/accounts/new");
  };

  const onEditClick = (account: Account) => {
    navigate(`/work/accounts/${account.idAccount}`);
  };

  const getSurveysCount = (account: Account) => {
    let surveyCount = 0;

    for (const loc of account.locations) {
      surveyCount += loc.surveys.length;
    }

    return surveyCount;
  };

  return (
    <Page
      pageTitle="Accounts"
      breadcrumbs={[{ linkName: "Accounts", linkUlr: "" }]}
    >
      <section className="section">
        <div className="card">
          {/* <div className="card-body">
            <div className="row g-3 align-items-center justify-content-between">
              <div className="col-auto">
                <form className="search-form">
                  <i className="bi bi-search search-icon"></i>
                  <input
                    type="search"
                    name="q"
                    placeholder="Search accounts..."
                    autoComplete="off"
                    value={accountSearch}
                    onChange={onSearchChange}
                  />
                </form>
              </div>
              <div className="col-auto ms-auto">
                <div className="d-flex flex-column align-items-end">
                  {subscription.canCreateAccounts && (
                    <>
                      <button
                        className="btn btn-primary"
                        onClick={() => onCreateAccountClick()}
                      >
                        <i className="bi bi-plus-lg me-1"></i> Create Account
                      </button>
                    </>
                  )}
                  <div
                    style={{
                      visibility: accounts.length > 0 ? "visible" : "hidden",
                    }}
                  >{`${accounts.length} accounts`}</div>
                </div>
              </div>
            </div>
          </div> */}

          <SearchBar
            placeHolderText="Search accounts..."
            searchValue={accountSearch}
            onSearchChange={onSearchChange}
            hasCreate={subscription.canCreateAccounts}
            createTitle="Create Account"
            onCreate={() => onCreateAccountClick()}
            count={accounts.length}
            countType="accounts"
          />

          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover table-responsive">
                <thead>
                  <tr>
                    <th scope="col">Account</th>
                    <th scope="col">Assignee</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">State</th>
                    <th scope="col">City</th>
                    <th scope="col">Locations Count</th>
                    <th scope="col">Surveys Count</th>
                    <th style={{ width: "50px" }} />
                  </tr>
                </thead>
                <tbody>
                  {accounts.map((account: Account) => (
                    <tr key={account.idAccount.toString()}>
                      <td>
                        <AccountLink account={account} />
                      </td>
                      <td>Assignee Placeholder</td>
                      <td>{account.email}</td>
                      <td>{account.phone}</td>
                      <td>{account.billingAddress?.state}</td>
                      <td>{account.billingAddress?.city}</td>
                      <td>{account.locations.length}</td>
                      <td>{getSurveysCount(account)}</td>
                      <td>
                        <i
                          className="ri-pencil-fill"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                          onClick={() => onEditClick(account)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Accounts;
